// 此文件为 npm run build 过程中自动创建，请勿修改文件内容

// 生成色彩
export const COLOR_B1 = '#e5f2ff';
export const COLOR_B2 = '#b3d9ff';
export const COLOR_B3 = '#80bfff';
export const COLOR_B4 = '#4da6ff';
export const COLOR_B5 = '#1a8cff';
export const COLOR_B6 = '#0073e6';
export const COLOR_B7 = '#0059b3';
export const COLOR_B8 = '#004080';
export const COLOR_B9 = '#00264d';
export const COLOR_B10 = '#000d1a';
export const COLOR_G1 = '#e9fbf5';
export const COLOR_G2 = '#bef4e2';
export const COLOR_G3 = '#93ecce';
export const COLOR_G4 = '#67e4bb';
export const COLOR_G5 = '#3cdda7';
export const COLOR_G6 = '#22c38e';
export const COLOR_G7 = '#1b986e';
export const COLOR_G8 = '#136c4f';
export const COLOR_G9 = '#0b412f';
export const COLOR_G10 = '#041610';
export const COLOR_O1 = '#fef5e6';
export const COLOR_O2 = '#fde0b4';
export const COLOR_O3 = '#fccb82';
export const COLOR_O4 = '#fbb750';
export const COLOR_O5 = '#faa21e';
export const COLOR_O6 = '#e18905';
export const COLOR_O7 = '#af6a04';
export const COLOR_O8 = '#7d4c03';
export const COLOR_O9 = '#4b2e02';
export const COLOR_O10 = '#190f01';
export const COLOR_R1 = '#feebe7';
export const COLOR_R2 = '#fbc2b6';
export const COLOR_R3 = '#f99986';
export const COLOR_R4 = '#f67055';
export const COLOR_R5 = '#f44725';
export const COLOR_R6 = '#da2e0b';
export const COLOR_R7 = '#aa2409';
export const COLOR_R8 = '#791a06';
export const COLOR_R9 = '#490f04';
export const COLOR_R10 = '#180501';
export const COLOR_I1 = '#e5e6eb';
export const COLOR_I2 = '#d3d6de';
export const COLOR_I3 = '#b6bac9';
export const COLOR_I4 = '#989fb3';
export const COLOR_I5 = '#7b839d';
export const COLOR_I6 = '#626a84';
export const COLOR_I7 = '#4c5367';
export const COLOR_I8 = '#363b49';
export const COLOR_I9 = '#21232c';
export const COLOR_I10 = '#0b0c0f';
export const COLOR_A1 = '#e6f4fe';
export const COLOR_A2 = '#b4dffd';
export const COLOR_A3 = '#82c9fc';
export const COLOR_A4 = '#50b4fb';
export const COLOR_A5 = '#1e9ffa';
export const COLOR_A6 = '#0585e1';
export const COLOR_A7 = '#0468af';
export const COLOR_A8 = '#034a7d';
export const COLOR_A9 = '#022c4b';
export const COLOR_A10 = '#010f19';
export const COLOR_M1 = '#fce9ef';
export const COLOR_M2 = '#f5bcce';
export const COLOR_M3 = '#ee90ae';
export const COLOR_M4 = '#e8648e';
export const COLOR_M5 = '#e1376d';
export const COLOR_M6 = '#c81e54';
export const COLOR_M7 = '#9b1741';
export const COLOR_M8 = '#6f112e';
export const COLOR_M9 = '#430a1c';
export const COLOR_M10 = '#160309';
export const COLOR_P1 = '#e8e7fe';
export const COLOR_P2 = '#bbb6fc';
export const COLOR_P3 = '#8e85fa';
export const COLOR_P4 = '#6154f8';
export const COLOR_P5 = '#3423f6';
export const COLOR_P6 = '#1b09dc';
export const COLOR_P7 = '#1507ab';
export const COLOR_P8 = '#0f057a';
export const COLOR_P9 = '#090349';
export const COLOR_P10 = '#030118';
export const COLOR_C1 = '#e8fdfd';
export const COLOR_C2 = '#b9f8f8';
export const COLOR_C3 = '#8af4f4';
export const COLOR_C4 = '#5cf0f0';
export const COLOR_C5 = '#2debeb';
export const COLOR_C6 = '#14d2d2';
export const COLOR_C7 = '#0fa3a3';
export const COLOR_C8 = '#0b7575';
export const COLOR_C9 = '#074646';
export const COLOR_C10 = '#021717';
// 主题色
export const COLOR_PRIMARY = '#0073e6';
export const COLOR_BRANCH = '#003f5f';
// 辅助色
export const COLOR_NORMAL = '#1e9ffa';
export const COLOR_SUCCESS = '#22c38e';
export const COLOR_WARNING = '#faa21e';
export const COLOR_DANGER = '#f44725';
export const COLOR_INFO = '#989fb3';
export const COLOR_SECONDARY = '#99a6b3';
export const COLOR_PURPLE = '#60f';
export const COLOR_PINK = '#f20df2';
export const COLOR_YELLOW = '#ffcc03';
export const COLOR_PRIMARY_HOVER = '#1a8cff';
export const COLOR_NORMAL_HOVER = '#50b4fb';
export const COLOR_SUCCESS_HOVER = '#3cdda7';
export const COLOR_WARNING_HOVER = '#fbb750';
export const COLOR_DANGER_HOVER = '#f67055';
export const COLOR_INFO_HOVER = '#b6bac9';
export const COLOR_SECONDARY_HOVER = '#40a9ff';
export const COLOR_DISABLED_HOVER = '#ccd3ee';
export const COLOR_PRIMARY_ACTIVE = '#0059b3';
export const COLOR_NORMAL_ACTIVE = '#0585e1';
export const COLOR_SUCCESS_ACTIVE = '#1b986e';
export const COLOR_WARNING_ACTIVE = '#e18905';
export const COLOR_DANGER_ACTIVE = '#da2e0b';
export const COLOR_INFO_ACTIVE = '#7b839d';
export const COLOR_SECONDARY_ACTIVE = '#096dd9';
export const COLOR_DISABLED_ACTIVE = '#899ec0';
export const COLOR_PRIMARY_LIGHT = '#e5f2ff';
export const COLOR_NORMAL_LIGHT = '#e6f4fe';
export const COLOR_SUCCESS_LIGHT = '#e9fbf5';
export const COLOR_WARNING_LIGHT = '#fef5e6';
export const COLOR_DANGER_LIGHT = '#feebe7';
export const COLOR_INFO_LIGHT = '#e5e6eb';
export const COLOR_SECONDARY_LIGHT = '#abbedd';
// 中性色 start
// 主要文字
export const NEUTRAL_COLOR_PRIMARY = '#0b0c0e';
// 常规文字
export const NEUTRAL_COLOR_REGULAR = '#21262c';
// 次要文字
export const NEUTRAL_COLOR_SECONDARY = '#4c5966';
// 第三颜色
export const NEUTRAL_COLOR_TERTIARY = '#788796';
// 占位文字
export const NEUTRAL_COLOR_PLACEHOLDER = '#98a6b3';
// 边框色
export const NEUTRAL_COLOR_BASE = '#d6dbe1';
// 填充色
export const NEUTRAL_COLOR_FILL = '#dfe3e7';
// 卡片色
export const NEUTRAL_COLOR_LIGHT = '#e8ebee';
// 分隔栏
export const NEUTRAL_COLOR_LIGHTER = '#f0f2f4';
// 页面背景
export const NEUTRAL_COLOR_EXTRALIGHT = '#f6f7f8';
// 提示文字
export const COLOR_TEXT_TIP = '#ced5e0';
// 反白色
export const COLOR_TEXT_WHITE = '#fff';
// 禁用色
export const COLOR_TEXT_DISABLED = '#bbcbe4';
// 表头色
export const COLOR_TEXT_HEADER = '#f0f3f7';
// 滚动条色
export const COLOR_SCROLL = '#98a6b3';
// 中性色 end
// Gradient Color
export const GRADIENT_COLOR_BRAND = 'linear-gradient(';
export const GRADIENT_COLOR_PRIMARY = 'linear-gradient(';
export const GRADIENT_COLOR_WARNING = 'linear-gradient(';
export const GRADIENT_COLOR_SUCCESS = 'linear-gradient(';
export const GRADIENT_COLOR_DANGER = 'linear-gradient(';
// 背景色
export const BACKGROUND_COLOR_BASE = '#f5f7fa';
export const TABLE_HEADER_BG_COLOR = '#f0f3f7';
// 字体 权重
export const FONT_WEIGHT_PRIMARY = '400';
export const FONT_WEIGHT_MEDIUM = '550';
export const FONT_WEIGHT_BOLD = '600';
// 字体 大小
export const FONT_SIZE_WEEK = '12px';
export const FONT_SIZE_MINI = '13px';
export const FONT_SIZE_BASE = '14px';
export const FONT_SIZE_MEDIUM = '16px';
export const FONT_SIZE_LARGE = '18px';
// 字体 line-heght
export const FONT_LINE_HEIGHT_WEEK = '16px';
export const FONT_LINE_HEIGHT_MINI = '17px';
export const FONT_LINE_HEIGHT_BASE = '19px';
export const FONT_LINE_HEIGHT_MEDIUM = '21px';
export const FONT_LINE_HEIGHT_LARGE = '24px';
// 边框颜色
export const BORDER_COLOR_BASE = '#d6dbe1';
export const BORDER_COLOR_REGULAR = '#e8ecfc';
// 8px 间距准则
export const GAP = '8px';
export const DOUBLE_GAP = '16px';
export const TRIPLE_GAP = '24px';
export const QUADRA_GAP = '32px';
export const BORDER_RADIUS = '4px';
export const BORDER_RADIUS_SMALL = '2px';
export const BORDER_RADIUS_MEDIUM = '4px';
export const BORDER_RADIUS_LARGE = '8px';
// border
export const BORDER_BASE = '1px solid #d6dbe1';
export const BORDER_DASHED = '1px dashed #d6dbe1';
// box-shadow 投影
export const BOX_SHADOW_LIGHT = '0px 0px 16px -6px rgba(0, 0, 0, 0.2)';
export const BOX_SHADOW_BASE = '0px 2px 28px 0px rgba(0, 0, 0, 0.16)';
export const BOX_SHADOW_DARK = '0px 2px 48px 16px rgba(0, 0, 0, 0.16)';
export const BOX_SHADOW_DOWN_LIGHT = '0px 6px 16px -8px rgba(0, 0, 0, 0.2)';
export const BOX_SHADOW_DOWN = '0px 8px 28px 0px rgba(0, 0, 0, 0.16)';
export const BOX_SHADOW_DOWN_DARK = '0px 12px 48px 16px rgba(0, 0, 0, 0.16)';
export const BOX_SHADOW_UP_LIGHT = '0px -6px 16px -8px rgba(0, 0, 0, 0.2)';
export const BOX_SHADOW_UP = '0px -8px 28px 0px rgba(0, 0, 0, 0.1)';
export const BOX_SHADOW_UP_DARK = '0px -12px 48px 16px rgba(0, 0, 0, 0.16)';
export const BOX_SHADOW_RIGHT_LIGHT = '6px 0px 16px -8px rgba(0, 0, 0, 0.2)';
export const BOX_SHADOW_RIGHT = '8px 0px 28px 0px rgba(0, 0, 0, 0.16)';
export const BOX_SHADOW_RIGHT_DARK = '12px 0px 48px 16px rgba(0, 0, 0, 0.16)';
export const BOX_SHADOW_LEFT_LIGHT = '-6px 0px 16px -8px rgba(0, 0, 0, 0.2)';
export const BOX_SHADOW_LEFT = '-8px 0px 28px 0px rgba(0, 0, 0, 0.16)';
export const BOX_SHADOW_LEFT_DARK = '-12px 0px 48px 16px rgba(0, 0, 0, 0.16)';
// 导航投影  ——用于顶部导航、节点 （具体请看模板使用规则）
export const NAV_BOX_SHADOW = '0px 4px 6px 2px rgba(165, 172, 197, 0.1)';
// 卡片投影  ——用于内容板块
export const CARD_BOX_SHADOW = '0px 0px 16px -6px rgba(0, 0, 0, 0.2)  //0px 2px 6px 4px rgba(165, 172, 197, 0.2)';
// 弹框投影  ——用于dialog、popover、popconfirm
export const DIALOG_BOX_SHADOW = '0px 2px 6px 4px rgba(165, 172, 197, 0.2)';
// 向上投影  ——用于固定在页面底部的板块
export const UP_BOX_SHADOW = '0px 2px 6px 4px rgba(165, 172, 197, 0.2)';
// 向左投影  ——用于列表固定列投影  x轴为负
export const LEFT_BOX_SHADOW = '0px 2px 6px 4px rgba(165, 172, 197, 0.2)';
// 向右投影  ——用于列表固定列投影  x轴为正
export const RIGHT_BOX_SHADOW = '0px 2px 6px 4px rgba(165, 172, 197, 0.2)';
// 菜单投影  ——用于菜单
export const MENU_BOX_SHADOW = '0px 2px 6px 4px rgba(165, 172, 197, 0.2)';
// 无投影  ——不设置投影，加上是为后期维护修改方便，有调整，只需搜索 $--no-box-shadow 关键字替换为需要修改后的投影名
export const NO_BOX_SHADOW = '0px 0px 0px 0px rgba(255, 255, 255, 0)';
// 输入框投影  ——选中
export const INPUT_SELECT_BOX_SHADOW = '0px 1px 3px 0px #0073e6';
// 输入框投影  ——警告
export const INPUT_DANGER_BOX_SHADOW = '0px 1px 3px 0px #f44725';
// 单选多选投影 ——选中
export const INPUT_SELECT_BASE_SHADOW = '0px 0px 2px 1px rgba(24, 144, 255, 0.3)';
export const INPUT_FOCUS_BOX_SHADOW = '0px 0px 3px 0px rgba(0, 114, 230, 0.5)';
// tooltip
export const TOOLTIP_FILL = '#001529';
export const TOOLTIP_BORDER_COLOR = '#001529';
// popover
export const POPOVER_PADDING = '16px';
export const POPOVER_PADDING_LARGE = '16px';
export const POPOVER_IMAGE_MAX_HEIGHT_WIDTH = '640px';
// table-fixed
export const TABLE_FIXED_BOX_SHADOW = '2px 0px 4px 2px rgba(165, 172, 197, 0.3)';
// 头像
export const AVATAR_SIZE_LARGE = '60px';
export const AVATAR_SIZE_MEDIUM = '40px';
export const AVATAR_SIZE_SMALL = '32px';
export const AVATAR_ICON_SIZE_LARGE = '36px';
export const AVATAR_ICON_SIZE_MEDIUM = '24px';
export const AVATAR_ICON_SIZE_SMALL = '20px';
export const AVATAR_FONT_SIZE_LARGE = '28px';
export const AVATAR_FONT_SIZE_MEDIUM = '20px';
export const AVATAR_FONT_SIZE_SMALL = '14px';
export const AVATAR_BORDER_RADIUS = '4px';
export const AVATAR_BORDER = '1px solid #ffffff';
// 节点图标颜色
export const NODE_COLOR_ICON = '#0073e6';
// table
export const TABLE_HEADER_BACKGROUND_COLOR = '#f0f2f4';
// ----------------------------  以上是对 element 变量重新定义  -----------------------------------
// 按钮
export const BUTTON_GAP = '8px';
export const BUTTON_HEIGHT_BASE = '32px';
export const BUTTON_FONT_WEIGHT = '400';
export const BUTTON_DEFAULT_BACKGROUND_COLOR = '#fff';
export const BUTTON_DEFAULT_BORDER_COLOR = '#d6dbe1';
export const BUTTON_DEFAULT_FONT_COLOR = '#21262c';
export const BUTTON_DEFAULT_HOVER_COLOR = '#1a8cff';
export const BUTTON_DEFAULT_ACTIVE_COLOR = '#0059b3';
export const BUTTON_PRIMARY_COLOR = '#fff';
export const BUTTON_FONT_SIZE = '14px';
export const BUTTON_PADDING_VERTICAL = '5px';
export const BUTTON_PADDING_HORIZONTAL = '12px';
export const BUTTON_BORDER_RADIUS = '4px';
export const BUTTON_MIN_WIDTH = '24px * 3';
export const BUTTON_GROUP_GAP = '8px';
export const BUTTON_GROUP_BUTTON_MORE_MIN_WIDTH = '8px * 6';
export const BUTTON_GROUP_BUTTON_MORE_HEIGHT = '32px';
export const HEADER_BUTTON_GROUP_HEIGHT = '50px';
// 回到顶部
export const BACKTOP_RADIUS_SMALL = '4px';
export const BACKTOP_RADIUS_MEDIUM = '8px';
export const BACKTOP_RADIUS_LARGE = '12px';
export const BACKTOP_RADIUS_XLARGE = '16px';
// search
export const SEARCH_GAP = '8px';
export const SEARCH_BORDER_RADIUS = '4px';
export const SEARCH_BOX_SHADOW = '0px 1px 3px 0px rgba(0, 89, 179, 0.5)';
export const QUERY_GAP = '8px';
export const QUERY_BORDER_RADIUS = '4px';
// layout and form
export const LAYOUT_GAP = '8px';
export const VIEW_BACKGROUND = '#f3f4f7';
export const FORM_WRAPPER_PADDING = '0 8px 24px 8px';
export const FORM_ITEM_MARGIN_TOP = '20px';
export const FORM_ITEM_BORDER_HEIGHT = '35px';
export const FORM_ITEM_HEIGHT = '28px';
export const ERROR_INPUT_BOX_SHADOW = '0px 1px 3px 0px #f44725';
export const TEXTAREA_BOX_SHADOW = '0px 1px 3px 0px #0073e6';
// 详情页
export const DETAIL_GAP = '8px';
export const DETAIL_HEADER_HEIGHT = '80px';
export const DETAIL_HEADER_SMALL_HEIGHT = '56px';
export const DETAIL_HEADER_GAP = '8px';
export const DETAIL_HEADER_BOX_SHADOW = '0px 4px 6px 2px rgba(165, 172, 197, 0.1)';
// 列表页
export const LIST_HEADER_GAP = '8px';
export const LIST_HEADER_HEIGHT = '80px';
export const LIST_HEADER_SMALL_HEIGHT = '56px';
export const LIST_HEADER_BOX_SHADOW = '0px 4px 6px 2px rgba(165, 172, 197, 0.1)';
// breadcrumb
export const BREADCRUMB_FONT_SIZE = '14px';
export const BREADCRUMB_FONT_COLOR_DEFAULT = '#0073e6';
export const BREADCRUMB_FONT_COLOR_HOVER = '#1a8cff';
export const BREADCRUMB_FONT_COLOR_ACTIVE = '#0b0c0e';
// card
export const CARD_GAP = '8px';
export const CARD_BACKGROUND = '#fff';
// collapse
export const COLLAPSE_PADDING = '20px';
export const COLLAPSE_HEADER_HEIGHT = '60px';
export const COLLAPSE_BUTTON_TEXT_COLOR = '#67707e';
// dialog
export const DIALOG_PADDING = '8px';
export const DIALOG_FOOTER_HEIGHT = '60px';
export const DIALOG_HEADER_HEIGHT = '60px';
export const DIALOG_BODY_MAX_HEIGHT = '90vh';
export const DIALOG_BODY_LARGE_MAX_HEIGHT = '80vh';
export const DIALOG_BODY_NORMAL_MAX_HEIGHT = '70vh';
export const DIALOG_BODY_SMALL_MAX_HEIGHT = '60vh';
// header-icon
export const HEADER_ICON_PADDING = '8px';
export const HEADER_ICON_BORDER_RADIUS = '4px';
// header-title
export const HEADER_TITLE_GAP = '8px';
export const HEADER_TITLE_LINE_HEIGHT = '8px * 3';
// label-group
export const LABEL_GROUP_MARGIN_RIGHT = '10px';
export const LABEL_GROUP_BORDER_RADIUS = '2px';
// loading
export const LOADING_COLOR_DOT = '#1a8cff';
export const LOADING_COLOR_CIRCLE = '#1a8cff';
// notification
export const NOTIFICATION_WIDTH = '330px';
// / padding||Spacing|3
export const NOTIFICATION_PADDING = '14px 26px 14px 13px';
export const NOTIFICATION_RADIUS = '8px';
export const NOTIFICATION_SHADOW = '0 2px 12px 0 rgba(0, 0, 0, 0.1)';
// / color||Color|0
export const NOTIFICATION_BORDER_COLOR = '#ebeef5';
export const NOTIFICATION_ICON_SIZE = '24px';
export const NOTIFICATION_CLOSE_FONT_SIZE = '16px';
export const NOTIFICATION_GROUP_MARGIN_LEFT = '13px';
export const NOTIFICATION_GROUP_MARGIN_RIGHT = '8px';
// / fontSize||Font|1
export const NOTIFICATION_CONTENT_FONT_SIZE = '14px';
// / color||Color|0
export const NOTIFICATION_CONTENT_COLOR = '#21262c';
// / fontSize||Font|1
export const NOTIFICATION_TITLE_FONT_SIZE = '16px';
// / color||Color|0
export const NOTIFICATION_TITLE_COLOR = '#0b0c0e';
// / color||Color|0
export const NOTIFICATION_CLOSE_COLOR = '#4c5966';
// / color||Color|0
export const NOTIFICATION_CLOSE_HOVER_COLOR = '#21262c';
// / color||Color|0
export const NOTIFICATION_SUCCESS_ICON_COLOR = '#22c38e';
// / color||Color|0
export const NOTIFICATION_INFO_ICON_COLOR = '#989fb3';
// / color||Color|0
export const NOTIFICATION_WARNING_ICON_COLOR = '#faa21e';
// / color||Color|0
export const NOTIFICATION_DANGER_ICON_COLOR = '#f44725';
// 通知中心
export const NOTICECENTER_BODER = '1px solid #e3e5e8';
export const NOTICECENTER_FONT_HOVER = '#3385ff';
export const NOTICECENTER_BACK_HOVER = '#e5f0ff';
export const NOTICECENTER_ICON_NOTIFICATION = '#0066ff';
export const NOTICECENTER_ICON_ANNOUNCE = '#2dd22d';
// 进度条
export const PROGRESS_BAR_BG = 'linear-gradient(';
export const PROGRESS_HEIGHT = '16px';
export const PROGRESS_BORDER_RADIUS = 'calc($--progress-height / 2)';
export const PROGRESS_GAP = '20px';
// section
export const SECTION_GAP = '8px';
export const SECTION_BORDER_RADIUS = '4px';
export const SECTION_HEADER_HEIGHT = '64px';
export const SUB_SECTION_HEADER_HEIGHT = '40px';
export const SECTION_TITLE_MARGIN_TOP = '2px';
// tab
export const TABS_ITEM_HEIGHT = '8px * 6';
export const TABS_ITEM_SMALL_HEIGHT = '8px * 6';
export const TABS_BODER_RADIUS = '2px';
export const TABS_PADDING = '0 24px';
export const TABS_BOX_SHADOW = '0px 4px 6px 2px rgba(165, 172, 197, 0.1)';
// table
export const TABLE_GAP = '8px';
export const TABLE_BORDER_RADIUS = '4px';
export const TABLE_DROPDOWN_HEIGHT = '60px';
export const TABLE_HEADER_TH_HEIGHT = '40px';
export const TABLE_BODY_TD_HEIGHT = '48px';
export const TABLE_BODY_TD_FONT_SIZE_MINI = '13px';
export const TABLE_BODY_TD_PADDING_MINI = '6px';
export const TABLE_BODY_TD_PADDING_SMALL = '8px';
export const TABLE_BODY_TD_PADDING = '12px';
export const TABLE_BODY_TD_PADDING_LARGE = '16px';
export const TABLE_BOX_SHADOW = '0px 2px 28px 0px rgba(0, 0, 0, 0.16)';
export const TABLE_STRIPED_BD = '#f0f2f4';
export const TABLE_PAGINATION_PAGER = '32px';
export const TABLE_PAGINATION_BORDER_RADIUS = '2px';
export const TABLE_STICKY_BG = '#182a3a';
// tag
export const TAG_GAP = '8px';
export const TAG_BORDER_RADIUS = '4px';
export const TAG_MARGIN_GAP = '12px';
export const TAG_BORDER_COLOR = '#a5b3c0';
// button-group
export const BUTTON_GROUP_BUTTON_HEIGHT = '40px';
export const BUTTON_GROUP_PADDING = '16px';
// checkbox
export const CHECKBOX_SIZE = '8px * 2';
// 详情页长按钮
export const DETAIL_BUTTON_FONT_SIZE = '14px';
export const DETAIL_BUTTON_COLOR = '#4c5966';
export const DETAIL_BUTTON_FONT_WEIGHT = '400';
export const DETAIL_BUTTON_BG_COLOR = '#fff';
export const DETAIL_BUTTON_PADDING = '8px 0';
export const DETAIL_BUTTON_BORDER_RADIUS = '4px';
export const DETAIL_BUTTON_HOVER_COLOR = '#0073e6';
export const DETAIL_BUTTON_ACTIVE_COLOR = '#0059b3';
export const DETAIL_BUTTON_BORDER_COLOR = '#d6dbe1';
// sidebarMenu
export const SIDEBAR_MENU_WIDTH = '220px';
export const SIDEBAR_MENU_COLLAPSE_WIDTH = '64px';
export const SIDEBAR_MENU_HEADER_GAP = '12px';
export const SIDEBAR_MENU_BODY_GAP = '16px';
export const SIDEBAR_MENU_DARK_BG_COLOR = '#001529';
export const SIDEBAR_MENU_DARK_HOVER_BG_COLOR = '#002f5c';
export const SIDEBAR_MENU_DARK_ACTIVE_COLOR = '#ffffff';
export const SIDEBAR_MENU_DARK_ACTIVE_BG_COLOR = '#0072e6';
export const SIDEBAR_MENU_DARK_OPEN_BG_COLOR = '#002547';
export const SIDEBAR_MENU_DARK_COLOR = 'rgba(#ffffff, 0.9)';
export const SIDEBAR_MENU_DARK_SEARCH_COLOR = '#ffffff';
export const SIDEBAR_MENU_DARK_SEARCH_BG_COLOR = '#042749';
export const SIDEBAR_MENU_DARK_SEARCH_PLACEHOLDER_COLOR = '#617384';
export const SIDEBAR_MENU_DARK_SEARCH_ICON_COLOR = '#ffffff';
export const SIDEBAR_MENU_DARK_SEARCH_FOCUS_ICON_COLOR = '#0072e6';
export const SIDEBAR_MENU_DARK_SEARCH_FOCUS_BORDER_COLOR = '#0072e6';
export const SIDEBAR_MENU_DARK_HIGHLIGHT_COLOR = '#ff9500';
export const SIDEBAR_MENU_LIGHT_BG_COLOR = '#ffffff';
export const SIDEBAR_MENU_LIGHT_HOVER_BG_COLOR = '#e5f2ff';
export const SIDEBAR_MENU_LIGHT_ACTIVE_COLOR = '#0059b3';
export const SIDEBAR_MENU_LIGHT_ACTIVE_BG_COLOR = '#e5f2ff';
export const SIDEBAR_MENU_LIGHT_OPEN_BG_COLOR = '#f3f5f6';
export const SIDEBAR_MENU_LIGHT_COLOR = '#0b0c0e';
export const SIDEBAR_MENU_LIGHT_SEARCH_COLOR = '#0b0c0e';
export const SIDEBAR_MENU_LIGHT_SEARCH_BG_COLOR = '#f4f5f5';
export const SIDEBAR_MENU_LIGHT_SEARCH_PLACEHOLDER_COLOR = '#99a6b3';
export const SIDEBAR_MENU_LIGHT_SEARCH_ICON_COLOR = '#617384';
export const SIDEBAR_MENU_LIGHT_SEARCH_FOCUS_ICON_COLOR = '#0072e6';
export const SIDEBAR_MENU_LIGHT_SEARCH_FOCUS_BORDER_COLOR = '#0072e6';
export const SIDEBAR_MENU_LIGHT_HIGHLIGHT_COLOR = '#ff9500';
export const POPUP_MODAL_OPACITY = '0.3';



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/variables/constants.js